import { apiBaseURL } from '../ProjectConstants';
import handleBackendResponse from '../handleNotifications/handleBackendResponse';


async function handleFormReceipt(orderId, image, imageName, fileType, fetch) {

    const formdata = new FormData();
    formdata.append("OrderId", orderId);
    formdata.append("Image", image, imageName);
    formdata.append("FileType", fileType);

    const response = await fetch.form(`${apiBaseURL}/api/Receipt`, formdata);
    //const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    const isDataGood = handleBackendResponse(response);

    console.log('handleFormReceipt orderId, image, imageName, fileType', orderId, image, imageName, fileType);
    console.log('handleFormReceipt response', response);

    return {
        response,
        isDataGood
    };
}

export default handleFormReceipt;